module.exports = __webpack_public_path__ + "img/eg-17-01.697b2c78.jpg";